import Vue from 'vue';

document.addEventListener('DOMContentLoaded', () => {
  const navigation = document.getElementById('js-navigation');

  if (navigation) {
    const vm = new Vue({
      delimiters: ['${', '}'],
      el: navigation,
      data: {
        isOpen: false,
        topLevelGroup: null,
        secondaryLevelGroup: null,
      },

      mounted() {
        const navigationMegaMenu = document.querySelector(
          '.navigation-mega-menu',
        );

        if (navigationMegaMenu) {
          navigationMegaMenu.addEventListener('click', (event) => {
            if (!event.target.closest('.navigation-mega-menu__inner')) {
              this.closeMegaMenu();
            }
          });
        }
      },

      methods: {
        setTopLevelGroup(group) {
          this.openMegaMenu();
          this.topLevelGroup = group;
          this.secondaryLevelGroup = null;
        },
        setSecondaryLevelGroup(group) {
          this.secondaryLevelGroup = group;
        },

        openMegaMenu() {
          this.isOpen = true;
          document.body.classList.add('no-scroll');
          document.addEventListener('keydown', this.handleEsc);
        },
        closeMegaMenu() {
          this.isOpen = false;
          document.removeEventListener('keydown', this.handleEsc);
          document.body.classList.remove('no-scroll');
          this.topLevelGroup = null;
          this.secondaryLevelGroup = null;
        },
        handleEsc(e) {
          if (e.keyCode === 27) {
            this.closeMegaMenu();
          }
        },
      },
    });
  }
});
